module.exports = __webpack_public_path__ + "static/assets/f114bc0671ed2a403802b6f562ee5d51.svg";